import React from 'react';

import styled, {keyframes} from 'styled-components';

interface ContentBoxProps {
    children: React.ReactNode
}

const fadeIn = keyframes`
  from {
    transform: translateY(-10px); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    transform: translateY(0); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;
const ContentBox:React.FC<ContentBoxProps> = ({children}) => {

return(
  <Container>
    <div>
    {children}
    </div>    

  </Container>
)

}
export { ContentBox };

const Container = styled.div`
    width: 100%;    
    flex: 1;
    padding: 30px;
    position: relative;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */

    @media screen and (max-width: 768px) {
  
        padding-top: 12px!important;
        padding-left: 12px!important;
        padding-right: 12px!important;
        padding-bottom: 12px!important;
    }
`;


